import { PdfViewerEventType, PdfViewerToggleSearchEvent } from '../../+types/pdf-viewer-event.type';
import { PdfViewerTranslationKey } from '../../+types/pdf-viewer-translations.type';
import { PDF_VIEWER_SVG_ICONS, PdfViewerIconType } from './../../+types/pdf-viewer-icon.type';
export class PdfSearchButtonComponent {
    constructor(container, eventBus, translations) {
        this.container = container;
        this.eventBus = eventBus;
        this.translations = translations;
        this.onPdfViewerSearchIsAvailable = () => {
            this.render();
        };
        this.onPdfViewerSearchIsUnAvailable = () => {
            this.renderUnavailable();
        };
        this.onSearchButtonClick = () => {
            this.eventBus.dispatch(new PdfViewerToggleSearchEvent());
        };
        this.eventBus.on(PdfViewerEventType.SearchIsAvailable, this.onPdfViewerSearchIsAvailable);
        this.eventBus.on(PdfViewerEventType.SearchIsUnavailable, this.onPdfViewerSearchIsUnAvailable);
    }
    render() {
        const element = document.createElement('div');
        element.innerHTML = `
            <button data-test-label="sp-pdf-viewer-search-button" class="sp-pdf-search-button">
                <span class="sp-pdf-search-button_wrapper">
                    <span class="icon">
                        ${PDF_VIEWER_SVG_ICONS[PdfViewerIconType.SearchOutlined]}
                    </span>
                </span>
                <span class="sp-pdf-search-button_focus-overlay"></span>
            </button>`;
        this.searchButtonElement = element.querySelector(`button`);
        this.container.appendChild(element);
        this.addEventListeners();
    }
    renderUnavailable() {
        this.container.innerHTML = `
        <button class="sp-pdf-search-button" title="${this.translations[PdfViewerTranslationKey.SearchComponentIsUnavailable]}" disabled>
            <span class="sp-pdf-search-button_wrapper">
                <span class="icon">
                    ${PDF_VIEWER_SVG_ICONS[PdfViewerIconType.SearchOutlined]}
                </span>
            </span>
            <span class="sp-pdf-search-button_focus-overlay"></span>
        </button>`;
    }
    addEventListeners() {
        this.searchButtonElement.addEventListener('click', this.onSearchButtonClick);
    }
    removeEventListeners() {
        var _a;
        this.eventBus.off(PdfViewerEventType.SearchIsAvailable, this.onPdfViewerSearchIsAvailable);
        this.eventBus.off(PdfViewerEventType.SearchIsUnavailable, this.onPdfViewerSearchIsUnAvailable);
        (_a = this.searchButtonElement) === null || _a === void 0 ? void 0 : _a.removeEventListener('click', this.onSearchButtonClick);
    }
    destroy() {
        this.removeEventListeners();
        this.container.innerHTML = '';
    }
}
//# sourceMappingURL=pdf-search-button.component.js.map